import React from "react";
import { Medal } from "lucide-react";

// Insignia 🏅 Embajador ConstruLink. Solo se muestra mientras el usuario
// pertenezca al Programa (es_embajador === true). Reconocimiento, no reemplaza la membresía.
export function EmbajadorBadge({ activo, size = "sm", className = "" }) {
  if (!activo) return null;
  const dims = size === "lg" ? "text-xs px-2.5 py-1 gap-1.5" : "text-[10px] px-2 py-0.5 gap-1";
  const iconSize = size === "lg" ? 13 : 11;
  return (
    <span
      data-testid="embajador-badge"
      title="Embajador ConstruLink"
      className={`inline-flex items-center rounded-full font-bold uppercase tracking-wide ${dims} ${className}`}
      style={{ color: "#B45309", backgroundColor: "#FEF3C7", border: "1px solid #B4530933" }}
    >
      <Medal size={iconSize} style={{ color: "#B45309" }} />
      Embajador
    </span>
  );
}

export default EmbajadorBadge;
